<template>
    <div class="home-component">
        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="120">
        </div>

        <div class="enter-membership-form">
                <div class="membership-input">

                    <div class="welcome-back-label" id="welcome-back-label"> </div>

                    <div class="welcome-back-label-subtext" id="welcome-back-label"> アカウントを保護する為に、パスワードを設定して下さい。</div>

                    <div class="membership-number-text-field-label-1" id="membership-number-text-field-label"> Email</div>
                <input class="membership-number-text-field" id="email-text-field" type="email" name="email">
                
                    <div class="membership-number-text-field-label-1" id="membership-number-text-field-label"> パスワード</div>
                <input class="membership-number-text-field" id="password-1-text-field" type="password" name="password">

                <div class="membership-number-text-field-label-2" id="membership-number-text-field-label">パスワードの確認</div>
                <input class="membership-number-text-field" id="password-2-text-field" type="password" name="password">


                <div class="membership-number-text-field-sub-label"> </div>
            </div>
            
            <button id="membership-number-submit" type="button" @click="confirmAccount" class="membership-number-submit">確認する</button>
        </div>
        
    </div>
</template>

<style scoped>
    .home-component {
        min-height: calc(100vh - 110px);
        display: flex;
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 50pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .membership-number-text-field {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        height: 35px;
    }

    .session-detail-component-header-logo {
        width: 100%;
        height: 100pt;
        object-fit: contain;
    }

    .welcome-back-label {
        font-family: SFPRoBold;
        color: white;
        font-size: 20pt;
        padding-top: 25pt;
    }

    .welcome-back-label-subtext {
        font-family: SFPRoRegular;
        color: white;
        font-size: 14pt;
        padding-top: 6pt;
    }

    .app-header {
        height: 100pt;
        display: flex;
        justify-content: left;
        align-items: left;
    }

    .enter-membership-form {
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
    }

    .membership-number-text-field {
        height: 30px;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label-1 {
        font-family: SFPRoBold;
        color: white;
        padding-top: 25pt;
    }

    .membership-number-text-field-label-2 {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 10pt;
        margin-bottom: 20pt;
    }

    .membership-number-submit {
    height: 40px;
    background-color: rgb(225, 228, 99);
    cursor: pointer;
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    width: 150pt
}

</style>

<script setup>
    import { store } from '../store.js'
    import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
    import { useRouter } from "vue-router";
    const router = useRouter();

    function confirmAccount() { 
        const email = document.getElementById("email-text-field").value;
        const pw1 = document.getElementById("password-1-text-field").value;
        const pw2 = document.getElementById("password-2-text-field").value;

        if (pw1 != pw2) {
            alert("パスワードが一致しません");
            return
        } 

            const auth = getAuth();

            document.getElementById("membership-number-submit").disabled = true;
            createUserWithEmailAndPassword(auth, email, pw1)
                .then((userCredential) => {
                const user = userCredential.user;
                document.getElementById("membership-number-submit").disabled = false;
                router.push('waiver-and-photos');
    })
    .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        document.getElementById("membership-number-submit").disabled = false;
        alert(errorMessage);
    });
    }
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);

        if (store.name != null) {
            document.getElementById('welcome-back-label').innerHTML = `Welcome, ${store.name}`
            document.getElementById('email-text-field').value = `${store.email}`
        }
    }
}
</script>